<template>
  <div class="wrapper">
    <img class="fullscreen-picture" src="../assets/judith_kevin_landing_page.png" alt="Fullscreen picture">

    <div class="text-overlay">
      <h1 class="white">Judith & Kevin</h1>
      <Carusel>
        <Kachel @click="navigate('bilder')">Bilder</Kachel>
      </Carusel>
    </div>
  </div>
</template>

<script>
import Carusel from './helper/Carusel.vue';
import Kachel from './helper/Kachel.vue';

export default {
  name: 'home-component',
  components: {
    Carusel,
    Kachel
  },
  methods: {
    navigate(goal) {
      this.$router.push('/hochzeit/' + goal);
    }
  }
};
</script>

<style scoped>
h1 {
  font-size: 9rem;
}

.wrapper {
  width: 100vw;
  height: 100vh;
  overflow: hidden;
}

.fullscreen-picture {
  width: 100vw;
  height: 100vh;
  object-fit: cover;
}

.text-overlay {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 80vw;
  height: 70vh;
  transform: translate(-50%, -50%);
  color: white;
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.white {
  color: white;
}

@media (max-width: 600px) {

  .text-overlay {
    width: 95vw;
    height: 90vh;
  }

  h1 {
    font-size: 6rem;
    line-height: 1;
    word-spacing: 10000px;
  }
}
</style>